import React, { FC, ReactNode } from 'react';
import { useRouteMatch } from 'react-router';

import * as paths from 'paths';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core'

import { Layouts } from 'components';
import * as Containers from './containers';

const useStyles = makeStyles(theme => ({
  fullWidth: {
    width: '752px',
    margin: `0 auto ${theme.spacing(4)}px`,
    [theme.breakpoints.up('lg')]: {
      paddingRight: theme.spacing(3),
    },
    flexWrap: 'nowrap'
  },
  maxWidth: {
    maxWidth: theme.breakpoints.values.md,
    [theme.breakpoints.up('lg')]: {
      paddingRight: 0,
    },
  },
}));

const PostController: FC = () => {
  const match = useRouteMatch();
  const classes = useStyles();

  const FullWidth = ({ children }: { children: ReactNode }) => (
    <Container className={classes.fullWidth}>{children}</Container>
  );

  let main = null;
  switch (match.path) {
    case paths.postCreate:
      main = (
        <FullWidth>
          <Containers.PostCreate />
        </FullWidth>
      )
      break;
    case paths.postEdit:
      main = (
        <FullWidth>
          <Containers.PostEdit />
        </FullWidth>
      )
      break;
    default:
      throw new Error('Unhandled Post Route');
  }

  return <Layouts.App1Column main={main} />;
}

export default PostController;